export default __webpack_public_path__ + "static/media/report.4ffcd68e.svg";